/* tslint:disable */
/* eslint-disable */
/**
 * 
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 0.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import type { Cpe } from './Cpe';
import {
    CpeFromJSON,
    CpeFromJSONTyped,
    CpeToJSON,
} from './Cpe';
import type { Cve } from './Cve';
import {
    CveFromJSON,
    CveFromJSONTyped,
    CveToJSON,
} from './Cve';
import type { Value2 } from './Value2';
import {
    Value2FromJSON,
    Value2FromJSONTyped,
    Value2ToJSON,
} from './Value2';

/**
 * 
 * @export
 * @interface ControlEntityTechResultData
 */
export interface ControlEntityTechResultData {
    /**
     * 
     * @type {Value2}
     * @memberof ControlEntityTechResultData
     */
    value?: Value2;
    /**
     * 
     * @type {string}
     * @memberof ControlEntityTechResultData
     */
    banner?: string;
    /**
     * 
     * @type {string}
     * @memberof ControlEntityTechResultData
     */
    method?: string;
    /**
     * 
     * @type {string}
     * @memberof ControlEntityTechResultData
     */
    name?: string;
    /**
     * 
     * @type {string}
     * @memberof ControlEntityTechResultData
     */
    product?: string;
    /**
     * 
     * @type {number}
     * @memberof ControlEntityTechResultData
     */
    confidence?: number;
    /**
     * 
     * @type {Cve}
     * @memberof ControlEntityTechResultData
     */
    cve?: Cve;
    /**
     * 
     * @type {Cpe}
     * @memberof ControlEntityTechResultData
     */
    cpe?: Cpe;
    /**
     * 
     * @type {string}
     * @memberof ControlEntityTechResultData
     */
    ostype?: string;
    /**
     * 
     * @type {string}
     * @memberof ControlEntityTechResultData
     */
    version?: string;
    /**
     * 
     * @type {string}
     * @memberof ControlEntityTechResultData
     */
    extrainfo?: string;
}

/**
 * Check if a given object implements the ControlEntityTechResultData interface.
 */
export function instanceOfControlEntityTechResultData(value: object): boolean {
    let isInstance = true;

    return isInstance;
}

export function ControlEntityTechResultDataFromJSON(json: any): ControlEntityTechResultData {
    return ControlEntityTechResultDataFromJSONTyped(json, false);
}

export function ControlEntityTechResultDataFromJSONTyped(json: any, ignoreDiscriminator: boolean): ControlEntityTechResultData {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'value': !exists(json, 'value') ? undefined : Value2FromJSON(json['value']),
        'banner': !exists(json, 'banner') ? undefined : json['banner'],
        'method': !exists(json, 'method') ? undefined : json['method'],
        'name': !exists(json, 'name') ? undefined : json['name'],
        'product': !exists(json, 'product') ? undefined : json['product'],
        'confidence': !exists(json, 'confidence') ? undefined : json['confidence'],
        'cve': !exists(json, 'cve') ? undefined : CveFromJSON(json['cve']),
        'cpe': !exists(json, 'cpe') ? undefined : CpeFromJSON(json['cpe']),
        'ostype': !exists(json, 'ostype') ? undefined : json['ostype'],
        'version': !exists(json, 'version') ? undefined : json['version'],
        'extrainfo': !exists(json, 'extrainfo') ? undefined : json['extrainfo'],
    };
}

export function ControlEntityTechResultDataToJSON(value?: ControlEntityTechResultData | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'value': Value2ToJSON(value.value),
        'banner': value.banner,
        'method': value.method,
        'name': value.name,
        'product': value.product,
        'confidence': value.confidence,
        'cve': CveToJSON(value.cve),
        'cpe': CpeToJSON(value.cpe),
        'ostype': value.ostype,
        'version': value.version,
        'extrainfo': value.extrainfo,
    };
}

